import React from "react";
import { Badge, Button } from "antd";
import { ShoppingCartOutlined } from "@ant-design/icons";
import { useCartNavigation } from "../hooks/useCartNavigation";

const FloatingCart = () => {
  const { handleCartClick, cartCount } = useCartNavigation();

  if (cartCount === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50">
      <Badge count={cartCount} size="small">
        <Button
          shape="circle"
          size="large"
          icon={<ShoppingCartOutlined style={{ fontSize: "18px" }} />}
          onClick={handleCartClick}
          className="shadow-md hover:shadow-lg transition-shadow"
          style={{
            width: "48px",
            height: "48px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#000",
            borderColor: "#000",
            color: "#fff",
          }}
        />
      </Badge>
    </div>
  );
};

export default FloatingCart;
